import React from "react";
import { FiFileText, FiSearch } from "react-icons/fi";
import type { APAADMINBaseModelsPageTreeNode } from "../../API/Models";

type PageTreeSearchResultsProps = {
	loading: boolean;
	error: string | null;
	results: APAADMINBaseModelsPageTreeNode[];
	onSelectPage: (node: APAADMINBaseModelsPageTreeNode) => void;
};

/** Page search results list in the tree view with click selection. */
const PageTreeSearchResults: React.FC<PageTreeSearchResultsProps> = ({
	loading,
	error,
	results,
	onSelectPage
}) => {
	if (loading) {
		return (
			<div className="flex items-center gap-2 text-sm text-slate-500">
				<FiSearch className="h-4 w-4" />
				Searching…
			</div>
		);
	}

	if (error) {
		return <div className="text-sm text-rose-600">{error}</div>;
	}

	if (!results.length) {
		return <div className="text-sm text-slate-500">No pages match your search.</div>;
	}

	return (
		<div className="space-y-2">
			{results.map((node, index) => (
				<button
					key={node.id ?? node.slug ?? node.path ?? `result-${index}`}
					type="button"
					onClick={() => onSelectPage(node)}
					className="flex w-full items-start gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2 text-left transition hover:border-slate-300 hover:bg-slate-50"
				>
					<div className="mt-0.5 rounded-md border border-slate-200 p-1 text-slate-500">
						<FiFileText className="h-4 w-4" />
					</div>
					<div className="min-w-0">
						<p className="truncate text-sm font-semibold text-slate-900">
							{node.title || node.name || node.slug || node.path || "Untitled"}
						</p>
						{node.slug && <p className="truncate text-[11px] text-slate-400">/{node.slug}</p>}
					</div>
				</button>
			))}
		</div>
	);
};

export default PageTreeSearchResults;
